import { Image } from '@pcln/horizon'
import { Box, Text } from 'pcln-design-system'

import { FlexWrapper, PrimaryBanner, SecondaryBanner } from './RotatingBanner.styled'

export default function RotatingBanner({
  image,
  primaryBannerText,
  secondaryBannerText,
  altText,
  imageClassName,
}: {
  imageClassName: string
  image: string
  primaryBannerText: string
  secondaryBannerText: string
  altText: string
}) {
  return (
    <FlexWrapper width={1} alignItems='center' flexDirection='column' justifyContent='center'>
      <PrimaryBanner color='primary' fontWeight='normal'>
        {primaryBannerText}
        <sup>*</sup>
      </PrimaryBanner>
      <SecondaryBanner alignItems='center' justifyContent='center'>
        <Text color='primary' fontWeight='normal'>
          {secondaryBannerText}
        </Text>
        {image && (
          <Box mx={3} width='310px'>
            <Image
              src={`${image}?opto&auto=avif,webp`}
              alt={altText}
              lazyLoad
              showSkeletonWhileLoading={false}
              className={`object-fill ${imageClassName}`}
            />
          </Box>
        )}
      </SecondaryBanner>
    </FlexWrapper>
  )
}
